import script from "./AsyncGqlTable.vue?vue&type=script&lang=ts&setup=true&generic=ORUF"
export * from "./AsyncGqlTable.vue?vue&type=script&lang=ts&setup=true&generic=ORUF"

import "./AsyncGqlTable.vue?vue&type=style&index=0&id=6a995e40&lang=scss"

const __exports__ = script;

export default __exports__